import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import api from '../lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuthCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');

        if (!code) {
          toast.error('Invalid authentication response');
          navigate('/auth', { replace: true });
          return;
        }

        const redirectUri = window.location.origin + '/auth/callback';
        const response = await api.post('/auth/google/callback', {
          code,
          redirect_uri: redirectUri,
        });
        const { token, user } = response.data;

        localStorage.setItem('midgard_token', token);
        loginWithToken(token, user);

        const isNewUser = user.wonder_coins === 50;
        toast.success(isNewUser
          ? 'Welcome to Midgard! You received 50 Runegold!'
          : 'Welcome back to Midgard!'
        );

        navigate('/home', { replace: true, state: { user } });

      } catch (error) {
        console.error('Google auth error:', error);
        toast.error('Google sign-in failed. Please try again.');
        navigate('/auth', { replace: true });
      }
    };

    processAuthCallback();
  }, [location.search, loginWithToken, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse-glow w-16 h-16 rounded-full bg-primary/20 mx-auto mb-4" />
        <p className="text-muted-foreground">Signing in with Google...</p>
      </div>
    </div>
  );
}
